<!--
무자료 수동등록 > 삭제
------------------------------------
-->
<template>
    <div>
        <h3>
            <i class="material-icons md-36">delete</i>
            <span class="uk-text-middle">무자료 삭제</span>
        </h3>
        <div class="input-form">
            <div class="uk-text-right">
            </div>
            <table class="input-table">
                <tr>
                    <th class="highlight">
                        <i class="material-icons">
                            local_shipping
                        </i>
                        트래킹번호
                    </th>
                    <td>
                        {{ prod.tracking_no }}
                    </td>

                </tr>

                <tr>
                    <th class="highlight">
                        <i class="material-icons">
                            account_circle
                        </i>
                        회원사
                    </th>
                    <td>
                        {{ prod.user_mailbox }}
                    </td>
                </tr>

                <tr>
                    <th class="highlight">
                        <i class="material-icons">
                            account_circle
                        </i>
                        수취인이름
                    </th>
                    <td>
                        {{ prod.tracking_recipient_name }}
                    </td>
                </tr>

                <tr>
                    <th class="highlight">
                        <i class="material-icons">
                            info
                        </i>
                        상품명
                    </th>
                    <td colspan="3">
                        {{ prod.name }}
                    </td>
                </tr>

                <tr>
                    <th class="highlight">
                        <i class="material-icons">
                            info
                        </i>
                        수량(QTY)
                    </th>
                    <td>
                        {{ prod.amount }}
                    </td>

                </tr>
                <tr>
                    <th class="highlight">
                        <i class="material-icons">
                            info
                        </i>
                        사이즈
                    </th>
                    <td>
                        {{ prod.size }}
                    </td>

                </tr>


                <tr>
                    <th>
                        <i class="material-icons">
                            info
                        </i>
                        색상
                    </th>
                    <td>
                        {{ prod.color }}
                    </td>
                </tr>
                <tr>
                    <th>
                        <i class="material-icons">
                            info
                        </i>
                        유통기한
                    </th>
                    <td>
                        {{ prod.expiration_date }}
                    </td>
                </tr>
                <tr>
                    <th>
                        <i class="material-icons">
                            receipt
                        </i>
                        해외주문번호
                    </th>
                    <td>
                        {{ prod.buy_order_code }}
                    </td>
                </tr>


                <tr>
                    <th>
                        <i class="material-icons">
                            location_on
                        </i>
                        보관장소
                    </th>
                    <td>
                        {{ prod.storage }}
                    </td>
                </tr>
                <tr>
                    <th>
                        <i class="material-icons">
                            comment
                        </i>
                        관리메모
                    </th>
                    <td colspan="3">
                        {{ prod.memo }}
                    </td>

                </tr>
            </table>

            <div class="uk-text-large uk-text-center uk-margin-top uk-text-danger">
                이 상품을 정말 삭제합니까?
            </div>

            <div class="uk-margin-top uk-text-center">

                <button
                    type="button"
                    class="uk-button uk-button-large uk-button-white uk-margin-right"
                    @click="$emit('click:cancel-remove')"
                >
                    <i class="material-icons">close</i> 취소
                </button>

                <button
                    type="button"
                    class="uk-button uk-button-large uk-button-danger"
                    @click="submit"
                >
                    <i class="material-icons">check_circle</i> 삭제(완료)
                </button>
            </div>
        </div>


        <!-- 완료창 -->
        <div ref="modal" class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
            <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-1-3">

                <div class="uk-modal-body">
                    <div class="uk-text-large3 uk-text-black uk-text-center">
                        삭제되었습니다.
                    </div>
                </div>

                <div class="uk-modal-footer uk-text-center">
                    <button
                        ref="buttonOk"
                        type="button"
                        class="uk-button uk-button-large uk-button-white"
                        @click="closeSuccessAlert"
                    >
                        <i class="material-icons">check</i> 확인
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        components: {
        },
        props: {
            // csrf-token
            csrfToken: String,

            /**
             * 로그인 유저 ID
             **/
            loginUserId: {
                type: Number,
                default: null,
            },


            /**
             * 지역id
             */
            regionId: {
                type: Number,
                default: null,
            },

            /**
             * 사용자명
             */
            loginUserName: {
                type: String,
                default: null,
            },

            // (array) 지역 회원사 옵션
            regionMemberOptions: {
                type: Array,
                default: [],
            },

            // (int) 업로드모듈에서 사용할 로그인ID
            sessionOwner: {
                type: Number,
                default: null,
            },



        },
        data: function () {
            return {
                // (object) 입력값
                inputs: {},

                // (object) 상품정보
                prod: {},

                // (bool) ajax 처리중여부 (중복실행방지)
                isAjaxing: false,
            };
        },
        mounted: function () {
        },
        computed: {

        },
        methods: {

            /**
             * 삭제 폼을 보여줌
             */
            show(prod) {

                this.prod = prod;
            },

            /**
             * 완료창 실행
             */
            openSuccessAlert() {
                UIkit.util.once(this.$refs.modal, 'shown', () => {
                    this.$refs.buttonOk.focus();
                });
                UIkit.modal(this.$refs.modal).show();
            },

            /**
             * 완료창 종료
             */
            closeSuccessAlert() {
                UIkit.util.once(this.$refs.modal, 'hidden', () => {
                    this.$emit('removed', this.prod);
                });
                UIkit.modal(this.$refs.modal).hide();
            },

            /**
             * submit
             */
            submit() {
                // 실행중이면 skip
                if (this.isAjaxing) {
                    return;
                }
                this.isAjaxing = true;

                // promise 생성
                let p = new Promise((resolve, reject) => {

                    // ajax 옵션
                    let opts = {
                        type: 'delete',
                        url: '/regions/' + this.regionId + '/nodata-stocks/' + this.prod.id,
                        data: {
                            '_token': this.csrfToken,
                        },
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                        error: function(jqXHR, textStatus, errorThrown) {
                            reject();
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });


                // promise 처리
                p.then((response) => {
                    this.openSuccessAlert();
                    //UIkit.modal(this.$refs.modal).show();
                }).catch(() => {
                    // 오류인경우
                }).finally(() => {
                    this.isAjaxing = false;
                });
            },

        },
    }
</script>

<style lang="scss" scoped>

    h3 {
        margin: 1rem 0 0 1rem;
        font-size: 1.25rem;
        font-weight: bold;
    }

    .input-form {
        margin: 0 1rem;
        padding: 1rem;
        // background-color: #fff;
        // border: 1px solid #cfcfcf;
    }


    // 테이블
    .input-table {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;

        th, td {
            text-align: left;
            border: 1px solid #999;
            font-weight: normal;

            padding: 0.25rem;
            color: #000;
        }

        th {

            font-size: 1.25rem;
            background-color: #fefefe;
            width: 10rem;

            .material-icons {
                vertical-align: middle;
                font-size: 1.75rem;
                color: #aaa;
            }

            &.highlight .material-icons{
                color: #1e87f0 !important;
            }

        }
        td {
            text-align: center;
            font-size: 1.25rem;
            background-color: #fff;
            color: #000;
            //width: 25rem;

            &.highlight {
                //background-color: #ffffdd;
            }
        }

    }
</style>